import React from 'react';
import { useNavigate } from 'react-router-dom';

const GameSidebar = ({ onRestart, onStyleChange, currentStyle }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-row sm:flex-col gap-4 mt-1 p-2 items-center justify-center">
      <button
        onClick={() => navigate('/')}
        className="p-2 rounded-full hover:bg-gray-700 transition-colors"
        title="Main Menu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>
      <button
        onClick={onRestart}
        className="p-2 rounded-full hover:bg-gray-700 transition-colors"
        title="Restart Game"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      </button>

      {/* Style Toggle Button */}
      <button
        onClick={() => onStyleChange(currentStyle === 'classic' ? 'original' : 'classic')}
        className="p-2 rounded-full hover:bg-gray-700 transition-colors"
        title="Toggle Game Style"
      >
        <div className="relative h-8 sm:h-12 w-10 sm:w-6 bg-gray-800 rounded-full p-1 flex flex-row sm:flex-col justify-between">
          {/* Toggle Track */}
          <div className="absolute inset-0 rounded-full bg-gray-700" />

          {/* Toggle Stones */}
          <div className="relative flex flex-row sm:flex-col h-full justify-between items-center">
            {/* Black Stone */}
            <div className={`
              w-4 h-4 rounded-full bg-black border-2 border-white transition-transform duration-300
              ${currentStyle === 'classic' ? 'scale-110' : 'scale-90'}
            `} />

            {/* Red Stone */}
            <div className={`
              w-4 h-4 rounded-full bg-red-600 border-2 border-white transition-transform duration-300
              ${currentStyle === 'original' ? 'scale-110' : 'scale-90'}
            `} />
          </div>
        </div>
      </button>
    </div>
  );
};

export default GameSidebar; 
